import { createContext } from "react" ;

export const LoginContext = createContext({});
// export const UsersContext = createContext({});
// export const UsersContext = createContext(null);
